import Link from '@material-ui/core/Link';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { useObserver } from 'mobx-react-lite';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../common/EnhancedTableHead';

interface Props {
  rows: any[];
}

const headRows: HeadRow[] = [
  { id: 'resourceType', disablePadding: true, label: 'Resource Type' },
  { id: 'resourceName', disablePadding: false, label: 'Name' },
  { id: 'actions', disablePadding: false, label: '', disableSorting: true }
];

const RESOURCE_TYPE_LABELS = {
  stack: 'CloudFormation Stack',
  s3Object: 'S3 Object',
  codeDeployDeployment: 'Code Deploy Deployment',
  lambdaFunction: 'Lambda Function',
  lambdaLayer: 'Lambda Layer'
};

const DEFAULT_ORDER_BY_FIELD = 'resourceType';

function FaroDeploymentResourcesTable(props: Props) {
  const { rows } = props;
  const [order, setOrder] = React.useState<Order>('asc');
  const [orderBy, setOrderBy] = React.useState<string>(DEFAULT_ORDER_BY_FIELD);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [page, setPage] = React.useState(0);

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const sortedRows = sortRows(rows, getSorting(order, orderBy));

  return useObserver(() => (
    <div>
      <Table>
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          fields={headRows}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
            <TableRow key={`${row.resourceType}:${row.resourceName}`}>
              <TableCell>
                {RESOURCE_TYPE_LABELS[row.resourceType]}
              </TableCell>
              <TableCell>
                {row.resourceName}
              </TableCell>
              <TableCell>
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href={row.href}
                >
                  View In Console
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  ));
};

export default FaroDeploymentResourcesTable;
